import React from "react";
import { Link } from "react-router-dom";
import Layout from "../layouts/Default";
import Text from "../components/typography/Text";
import Textarea from "../components/inputs/Textarea";
import Button from "../components/buttons/Button";
import fetchApi from "../fetchApi";

export default ({ location }) => {
  const [comment, setComment] = React.useState();
  const [sent, setSent] = React.useState(false);
  const { designer } = location.state;

  const send = async () => {
    const formData = new FormData();

    formData.append("comment", comment);
    formData.append("to", designer.id);
    const options = {
      method: "post",
      body: formData,
    };
    const result = await fetchApi("/mail/workwith/", options, false);

    if (
      result &&
      (result.code === 200 ||
        result.message === "Could not instantiate mail function.")
    ) {
      setSent(true);
    }
  };

  if (!designer) return <div>Not found</div>;
  return (
    <Layout title={`Work with ${designer.name}`}>
      <div className="pWorkWith">
        {!sent ? (
          <div className="pWorkWith_content">
            <h3>I want to work with {designer.name}</h3>
            <Text>
              Provide a compelling paragraph on why you would like to work with
              this designer. This will greatly increase your chance of being put
              in relation for an interview by our team.
            </Text>
            <Textarea label="Comment" value={comment} setValue={setComment} />
            <Button big onClick={send}>
              Send my request
            </Button>
          </div>
        ) : (
          <div className="pWorkWith_content">
            <h3>Message sent. Thank you !</h3>
            <Link to={`/designer/${designer.slug}`}>
              Go back to {designer.name} profile
            </Link>
          </div>
        )}
      </div>
    </Layout>
  );
};
